import AgendaVisitaDiariaView from "../../components/agenda-visita-diaria-view/AgendaVisitaDiariaView";

export default function AgendaVisitaDiariaPage() {
  return <AgendaVisitaDiariaView title="Agenda Visita Diaria" />
}